import { AwsRum, type AwsRumConfig } from 'aws-rum-web';

export const startAwsRum = () => {
  let identityPoolId = 'eu-west-1:f9970cbb-0cfa-4bef-8869-374cdea871df';
  let applicationId = 'a017ea7d-6b88-4586-9c07-8230714fc2a6';
  if (import.meta.env.VITE_ENV === 'prod') {
    identityPoolId = 'eu-west-1:e521dc33-c8e6-435f-988c-096e87e44a6d';
    applicationId = 'f252372e-a63f-42cd-8b73-d7510638a3ae';
  }
  console.log('Starting AWS RUM in env: ', import.meta.env.VITE_ENV);
  try {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId,
      endpoint: 'https://dataplane.rum.eu-west-1.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: true,
      signing: true, // If you have a public resource policy and wish to send unsigned requests please set this to false
    };

    const APPLICATION_ID = applicationId;
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = 'eu-west-1';

    new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
    console.log('AWS RUM initialized successfully.');
  } catch (error) {
    console.error('Error initializing AWS RUM:', error);
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
};
